
import React, { ReactNode } from "react";

interface IProps {
  children: ReactNode | ReactNode[];
}

const CpntFormSectionNavigation: React.FC<IProps> = ({ children }) => {
  return (
    <>
      {Array.isArray(children) ? (
        <div className="pae-form-footer row justify-content-between">
          {React.Children.map(children, (child, i) => {
            if (child) {
              return (
                <div key={"CpntFormSectjustify-content-betweenionNavigation" + i} className="col-auto">
                  {child}
                </div>
              );
            }
          })}
        </div>
      ) : (
        <div className="pae-column ">{children}</div>
      )}
    </>
  );
};

export default CpntFormSectionNavigation;
